import { Modal } from "~/jose_modern/modal";

const DEFAULT_MODAL_SELECTOR = "#subscriber-feature-modal";

function setText(el, value) {
  const fallback = el.dataset.default ?? "";
  el.textContent = value || fallback;
}

document.addEventListener("click", (event) => {
  const trigger = event.target.closest("[data-subscriber-feature]");
  if (!trigger) return;

  event.preventDefault();

  const modalSelector = trigger.dataset.modalTarget || DEFAULT_MODAL_SELECTOR;
  const modal = document.querySelector(modalSelector);

  setText(modal.querySelector("[data-pitch]"), trigger.dataset.pitch);
  setText(modal.querySelector("[data-pitch-heading]"), trigger.dataset.pitchHeading);
  setText(modal.querySelector("[data-pitch-cta]"), trigger.dataset.pitchCta);
  setText(
    modal.querySelector("[data-pitch-mobile-cta]"),
    trigger.dataset.pitchMobileCta || trigger.dataset.pitchCta
  );

  Modal.show(modalSelector);
});
